export default "__VITE_ASSET__BFrBWK8m__"